import React, { useEffect, useState, useCallback } from 'react';

import { updateDoc } from '../dbHandler'

let firebase = window.firebase
let firebaseFirestore = window.firebaseFirestore
let firebaseMessaging = window.firebaseMessaging

let defaultUser = { loggedIn: false }

let UserContext = React.createContext(defaultUser)
let UserProvider = UserContext.Provider

function AuthUserProvider(props) {

  let userInfo = localStorage.getItem('user') // get the saved info
  userInfo = JSON.parse(userInfo)

  let [user, setUser] = useState({
    loggedIn: false,
    loading: true,
    ...userInfo
  })

  let [loading, setLoading] = useState(false)
  let [error, setError] = useState("")

  useEffect(() => {
    let unsubscribe = onAuthStateChange(setUser, user)
    let unsubscribeMsg = firebaseMessaging?.onTokenRefresh(handelTokenRefresh)

    return () => {
      unsubscribe()
      unsubscribeMsg && unsubscribeMsg()
    }
  }, [])

  useEffect(() => {

    if (user.id)
      localStorage.setItem('user', JSON.stringify(user))

  }, [user])

  let requestLogout = useCallback(() => {
    logout()
    setUser({
      loggedIn: false,
      loading: false,
    })
  }, [])

  let updateUserInfo = (info) => setUser({ ...user, ...info })

  let requestUpdateUserInfo = useCallback(() => {
    firebaseFirestore.doc('staff/' + user.ownerID)
      .get()
      .then(doc => setUser({ ...user, ...doc.data() }))
      .catch(error => setError(error))
  })

  return (
    <UserProvider value={{
      user,
      updateUserInfo,
      error,
      loading,
      requestLogout,
      requestUpdateUserInfo,
    }}>
      {props.children}
    </UserProvider>
  )
}

export { UserContext, AuthUserProvider }

function onAuthStateChange(callback, userState) {

  return firebase.auth().onAuthStateChanged(user => {
    if (user) {

      let { email } = user

      callback({
        ...userState,
        email,
        loading: true,
      })

      // get the user info (from Owners collection)
      firebaseFirestore.collection('staff').where('email', '==', email).limit(1).get()
        .then(async querySnapshot => {

          if (!querySnapshot.empty) {

            let data

            querySnapshot.forEach((doc) => {
              data = doc.data()
              data.id = doc.id
            })

            if (!localStorage.getItem('currentMsgToken')) await getFbMessagingPermission()

            callback({
              loggedIn: true,
              loading: false,
              ...data
            })

          } else {
            callback({
              loggedIn: false,
              loading: false,
            }) // it's an auth account but not an owner 
          }

        })
        .catch(error => {
          callback({
            loggedIn: true,
            loading: false,
            error
          })
        })

    } else {
      callback({
        loggedIn: false,
        loading: false,
      })
    }
  })
}

function logout() {

  clearCurrentMsgToken()
  localStorage.removeItem('user')
  firebase.auth().signOut()

}

function clearCurrentMsgToken() {

  let { id } = JSON.parse(localStorage.getItem('user'))
  let currentMsgToken = localStorage.getItem('currentMsgToken')

  // remove the token from staff registered tokens
  firebaseFirestore.doc(`staff/${id}`).update({
    "msgTokens": firebase.firestore.FieldValue.arrayRemove(currentMsgToken)
  })

  localStorage.removeItem('currentMsgToken')

  if (firebaseMessaging)
    firebaseMessaging.deleteToken()

}

// browser messaging permistion
export async function getFbMessagingPermission() {

  try {

    await firebaseMessaging.requestPermission()
    console.log(`Notification Permission ✔️`)

    return await handelTokenRefresh()

  } catch (error) {

    console.log(`Notification Permission ❌`)
  }

}

// save the token at current staff document
async function handelTokenRefresh() {

  try {

    // get staff doc
    let uid = firebase.auth().currentUser.uid
    let currentStaffRef = firebaseFirestore.collection('staff').where('uid', '==', uid).limit(1).get()

    let tokenPromise = firebaseMessaging?.getToken()

    let [currentStaffDoc, msgToken] = await Promise.all([
      currentStaffRef,
      tokenPromise,
    ])

    if (msgToken && !currentStaffDoc.empty) { // has a permission & staff doc exist

      // get staff doc id
      let snapshot = currentStaffDoc.docs[0]
      let staffDocId = snapshot.id
      let { msgTokens = [] } = snapshot.data()

      msgTokens.push(msgToken)
      console.log({ msgTokens });

      // save the new token locally >> to delete it later after loged out
      localStorage.setItem('currentMsgToken', msgToken)

      // save the user msg tokens
      updateDoc({ msgTokens }, `staff/${staffDocId}`)

    }

  } catch (error) {
    console.log('handelTokenRefresh: ', error)
  }

}